<template>
  <div>
    <Breadcrumb :items="breadcrumbItems" />
    
    <SecaoForm
      @save="handleSave"
      @cancel="handleCancel"
    />
  </div>
</template>

<script>
import Breadcrumb from "../../../components/breadcrumbs/Breadcrumb.vue";
import SecaoForm from "../../../components/forms/SecaoForm.vue";
import { SecaoService } from "../../../services/SecaoService";

export default {
  name: "CriarSecao",
  components: {
    Breadcrumb,
    SecaoForm
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "Página Inicial",
          disabled: false,
          href: "/"
        },
        {
          text: "Gerenciamento de Seções",
          disabled: false,
          href: "/secoes"
        },
        {
          text: "Cadastro de Seção",
          disabled: true,
          href: "/secoes/criar"
        }
      ]
    };
  },
  methods: {
    async handleSave(formData) {
      try {
        // Criar FormData seguindo o padrão existente
        const postData = new FormData();
        
        postData.append("codigo_secao", formData.codigoSecao);
        postData.append("descricao", formData.descricao);
        postData.append("ativo", formData.ativo ? 1 : 0);
        
        const response = await SecaoService.store(postData);
        
        if (response) {
          // Redirecionar para a lista de seções após salvar
          this.$router.push('/gerenciar-secoes');
        } else {
          throw new Error('Erro ao criar seção');
        }
      } catch (error) {
        console.error('Erro ao criar seção:', error);
        // O componente SecaoForm já trata a exibição de mensagens de erro
        throw error;
      }
    },
    handleCancel() {
      // Retornar para a tela principal do menu
      this.$router.push('/gerenciar-secoes');
    }
  }
};
</script>

<style scoped>
/* Estilos específicos da página, se necessário */
</style>